<template>
  <ToggleSection label="Sample Preparation" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[['is_control', 'is_single_cell', 'has_plate_position']]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SamplePreparation',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
